import { useContext } from 'react';
import { ToastNotificationContext } from '@context';

export const useToastNotificationContext = () => {
  const context = useContext(ToastNotificationContext);
  return context;
};
